export const useLocalStorage = (
    name: string,
    tableName: string,
    activeProfile: Models.Profile | undefined,
) => {
    const getForActiveProfile = () => {
        if (!activeProfile) {
            return undefined
        }

        const json = localStorage.getItem(name)
        if (!json) {
            return undefined
        }
        const preferencesObject = JSON.parse(json)
        if (!preferencesObject) {
            return undefined
        }

        return preferencesObject[activeProfile.profile_id.toString()]
    }

    const get = () => {
        if (!activeProfile) {
            return undefined
        }

        const json = localStorage.getItem(name)
        if (!json) {
            return undefined
        }
        const preferencesObject = JSON.parse(json)
        if (!preferencesObject) {
            return undefined
        }

        return preferencesObject
    }

    const set = (data: Object) => {
        if (!activeProfile) {
            return
        }

        const storedProfilePreferences = get()
        const incomingProfilePreferences = {
            [activeProfile.profile_id]: {
                [tableName]: data,
            },
        }

        if (!Object(storedProfilePreferences).hasOwnProperty(activeProfile.profile_id.toString())) {
            const incoming = JSON.stringify({
                ...storedProfilePreferences,
                ...incomingProfilePreferences,
            })
            localStorage.setItem(name, incoming)
            return
        }

        const storedProfilePreferencesData =
            storedProfilePreferences[activeProfile.profile_id.toString()]
        const exists = Object(storedProfilePreferencesData).hasOwnProperty(tableName)

        // if exists
        if (exists) {
            storedProfilePreferencesData[tableName] = {
                ...storedProfilePreferencesData[tableName],
                ...data,
            }
        } else {
            storedProfilePreferencesData[tableName] = data
        }

        storedProfilePreferences[activeProfile.profile_id.toString()] = storedProfilePreferencesData
        localStorage.setItem(name, JSON.stringify(storedProfilePreferences))
    }

    return {
        set,
        get,
        getForActiveProfile,
    }
}
